import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import UpdateBusinessDeliverySlot from '../UpdateBusinessDeliverySlot/UpdateBusinessDeliverySlot';
import {myDeliveries, changeHandler, validateHandler, deliveryCallBack} from './UpdateBusinessDeliverySlotHolderSlice';
import {backToDeliveries, endProcess} from '../UpdateBusinessDeliverySlot/UpdateBusinessDeliverySlotSlice';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';
import Image from 'app/Components/Shared/Image/image';
const UpdateBusinessDeliverySlotHolder = (props) => {
  useEffect(() => {
    gaEvent(gaParams.DELIVERY_SLOT_START.category, gaParams.DELIVERY_SLOT_START.eventType, gaParams.DELIVERY_SLOT_START.eventParams);
    if (props.isFullAuthenticated) {
      if (!props.myDeliveriesList) {
      }
    }
    return () => {
      props.endProcess();
    };
  }, []);

  useEffect(() => {
    if (props.isShowFail) {
      props.hideAppLoader();
      gaEvent(gaParams.DELIVERY_UPDATE_FAIL.category, gaParams.DELIVERY_UPDATE_FAIL.eventType, gaParams.DELIVERY_UPDATE_FAIL.eventParams);
    }
  }, [props.isShowFail]);

  useEffect(() => {
    if (props.form.valid) {
      props.showAppLoader();
      createCallback(props);
    }
  }, [props.form.valid]);

  useEffect(() => {
    if (props.iMEIDeviceRepair?.deliveries?.length === 0) {
      gaEvent(gaParams.DELIVERY_NOT_FOUND.category, gaParams.DELIVERY_NOT_FOUND.eventType, gaParams.DELIVERY_NOT_FOUND.eventParams);
      props.hideAppLoader();
    }
  }, [props.iMEIDeviceRepair?.deliveries]);

  const callSupportClicked = () => {
    gaEvent(gaParams.DELIVERY_CALL_SUPPORT.category, gaParams.DELIVERY_CALL_SUPPORT.eventType, gaParams.DELIVERY_CALL_SUPPORT.eventParams);
  };

  const checkNoteOrder = () => {
    let noteOrderArr = [];
    props.myDeliveriesList?.map(function(item, index) {
      noteOrderArr[index] = {idx: index, noteOrder: item.noteOrder};
    });
    let sameNoteOrder;
    if (noteOrderArr.length > 1) {
      sameNoteOrder = noteOrderArr.reduce((unique, o) => {
        if (!unique.some((obj) => obj.noteOrder != o.noteOrder)) {
          unique.push(o);
        }
        return unique;
      }, []);
      return sameNoteOrder;
    } else {
      return (sameNoteOrder = false);
    }
  };

  const checkForDeliveries = () => {
    console.log(props);

    try {
      return (
        <div className='deliveries-not-found'>
          {props.myDeliveriesList?.length === 0 ? (
            <div>
              אוי, נראה שאין פה אף אחד על הטוסטוס
              <br></br>
              אם בכל זאת אמורה להגיע אליכם שליחות מוזמנים להתקשר ל- {props.numberCallCenter}{props.isPrivate && " או ל-052-9990777"}
              <br></br>
              בשעות הפעילות:
              <br></br>
              א-ה 8:00-18:00
              <br></br>
              ו' וערבי חג 8:00-13:00
            </div>
          ) : (
            props.myDeliveriesList?.map(function(item, index) {
              return (
                <div key={index}>
                  <UpdateBusinessDeliverySlot
                    data={item}
                    idx={index}
                    slotsCount={props.myDeliveriesList?.length}
                    sameNoteOrders={checkNoteOrder()}
                    contentData={props.contentData}
                  />
                </div>
              );
            })
          )}
        </div>
      );
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const deliveryUpdateFail = () => {
    let callServiceCenter = props.props.deviceRepairData.isPrivate ? 'tel:' + props.props.deviceRepairData.numberCallCenter : `tel:050000000`;
    return (
      <Row>
        <Col>
          {props.isShowErrorPage ? (
            <>
              <p className='response-title'>לקוח יקר, התקבלה שגיאה בביצוע הפעולה.</p>
              <p className='delivery-text'>נא פנה לאחראי/ת שירות להמשך טיפול</p>
              <div className='delivery-man-img'>
                <Image src={require('./images/icons-error.svg')} alt='כישלון'/>
              </div>
              <Row>
                <Col className='submit-CallBack'>
                  <a className='call-service-center' href={callServiceCenter} onClick={() => callSupportClicked()}>
                    <Image src={require('./images/icons-call-phone.svg')} alt='דבר איתנו'/>
                    <div> דברו איתנו</div>
                  </a>
                </Col>
              </Row>
              <div className='back-personal-area' onClick={() => EpiContext.navigateTo(Config.lobbyUrl)}>
                <span>חזרה לאזור האישי</span>
              </div>
            </>
          ) : (
            showCallBackResponse()
          )}
        </Col>
      </Row>
    );
  };

  return (
    <Container className='delivery-slot-container'>
      {props.isShowFail === true ? deliveryUpdateFail() : <div>{checkForDeliveries()}</div>}
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    myDeliveriesList: state.iMEIDeviceRepair.deliveries,
    isShowFail: state.updateBusinessDeliverySlot.isShowFail,
    updateSuccess: state.updateBusinessDeliverySlot.updateSuccess,
    form: state.updateBusinessDeliverySlotHolder.form,
    isCallBackSuccess: state.updateBusinessDeliverySlotHolder.isCallBackSuccess,
    isCallBackFail: state.updateBusinessDeliverySlotHolder.isCallBackFail,
    isShowErrorPage: state.updateBusinessDeliverySlotHolder.isShowErrorPage,
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
  };
};

const mapDispatchToProps = {
  myDeliveries,
  changeHandler,
  validateHandler,
  showAppLoader,
  hideAppLoader,
  deliveryCallBack,
  backToDeliveries,
  endProcess,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateBusinessDeliverySlotHolder);
